import { render, staticRenderFns } from "./BookingsInRoom.vue?vue&type=template&id=6cb8813c&"
import script from "./BookingsInRoom.vue?vue&type=script&lang=js&"
export * from "./BookingsInRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports